export const FILE = '/api/v1/files';
export const ADD_TEMPORARY_FILE = '/api/v1/files/temporary';
export const GET_FILES_IN_ZIP = '/api/v1/files/download-zip';
